import {Component, OnInit, ViewChild} from '@angular/core';
import {TGiftVoucherLedger} from './model/t-gift-voucher-ledger';
import {SnotifyService} from 'ng-snotify';
import {NgxSpinnerService} from 'ngx-spinner';
import {TransactionSummaryDashboardService} from './service/transaction-summary-dashboard.service';

@Component({
  selector: 'app-transaction-summary-dashboard',
  templateUrl: './transaction-summary-dashboard.component.html'
})
export class TransactionSummaryDashboardComponent implements OnInit {

  @ViewChild('inputForm') inputForm;
  private tGiftVoucherLedgerList: TGiftVoucherLedger [] = [];
  private uiMode: string;
  private transactionSummaryDashboard: TransactionSummaryDashboard;

  constructor(private transactionSummaryDashboardService: TransactionSummaryDashboardService,
              private snotifyService: SnotifyService,
              private spinner: NgxSpinnerService,) {
    this.transactionSummaryDashboard = new TransactionSummaryDashboard();
  }

  ngOnInit() {
    this.transactionSummaryDashboard.trasactionType = 'GV';
    this.uiMode = 'IDEAL';
  }

  newFormData(): void {
    this.uiMode = 'EDIT';
  }

  clearFormData(): void {
    this.transactionSummaryDashboard = new TransactionSummaryDashboard();
    this.transactionSummaryDashboard.trasactionType = 'GV';
    this.tGiftVoucherLedgerList = [];
    this.uiMode = 'IDEAL';
  }

  clearBarcode(): void {
    this.transactionSummaryDashboard.barcode = '';
  }

  replaceWord(word: string): string {
    for (var i = 0; i < word.length; i++) {
      word = word.replace('_', ' ');
    }
    return word;
  }

  findByTransactionNumber(): void {
    this.spinner.show();
    if (!this.transactionSummaryDashboard.trasactionType) {
      this.snotifyService.warning('Please Enter Trasaction Number', 'WARNING', {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else if (!this.transactionSummaryDashboard.barcode) {
      this.snotifyService.warning('Please Enter Trasaction Number', 'WARNING', {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else {
      this.transactionSummaryDashboardService.getSummaryDashboardDetails(this.transactionSummaryDashboard.trasactionType, this.transactionSummaryDashboard.barcode).subscribe((data) => {
          this.tGiftVoucherLedgerList = data;
          this.spinner.hide();
        },
        (e) => {
          this.tGiftVoucherLedgerList = [];
          this.spinner.hide();
          this.snotifyService.error(e.error.message, 'ERROR', {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true
          });
        });
    }
  }
}

export class TransactionSummaryDashboard {
  trasactionType: string;
  barcode: string;
}



// WEBPACK FOOTER //
// ./src/app/view/dashboard/transaction-summary-dashboard/transaction-summary-dashboard.component.ts